import { useCallback, useEffect, useState } from "react";

const KEY = "admin_theme";

function preferido() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

/** Tema do /admin: aplica `admin-theme` (+ `dark`) no <html> só enquanto montado. */
export function useAdminTheme() {
  const [theme, setThemeState] = useState(() => localStorage.getItem(KEY) || "system");
  const resolved = theme === "system" ? preferido() : theme;

  useEffect(() => {
    const root = document.documentElement;
    const accentInline = root.style.getPropertyValue("--accent");
    root.classList.add("admin-theme");
    root.style.removeProperty("--accent");
    return () => {
      root.classList.remove("admin-theme", "dark");
      if (accentInline) root.style.setProperty("--accent", accentInline);
    };
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", resolved === "dark");
  }, [resolved]);

  const setTheme = useCallback((t) => {
    localStorage.setItem(KEY, t);
    setThemeState(t);
  }, []);

  return { theme, resolved, setTheme };
}
